import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { NotFoundPage } from '@/pages/NotFoundPage';

const NotFoundPageContainer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <NotFoundPage
      title={t('pages.notFound.title')}
      description={t('pages.notFound.description')}
      subdescription={t('pages.notFound.subdescription')}
    />
  );
};

export default NotFoundPageContainer;
